import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Table } from '@cureskin/api-client';
import { ConnectionService } from '@services/connection-service';
import { ChatProgressService } from '@services/chat-progress-service/chat-progress.service';
import { ConsultationSessionService } from '@services/consultation-session-service';
import { EventLoggerService } from '@services/event-logger-service';
import { LanguageChangeComponent } from '@shared/bottom-sheet-layouts/language-change/language-change.component';
import { AppConfig } from 'client/app/app.config';

@Component({
  selector: 'chat-language-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-language-pill.component.html',
})
export class ChatLanguagePillComponent {
  readonly consultationSession = input<Table.ConsultationSession>();
  readonly botReplyInProgress = input(false);
  readonly translateChatMessages = input(true);

  private readonly bottomSheet = inject(MatBottomSheet);
  private readonly consultationSessionService = inject(ConsultationSessionService);
  private readonly chatProgressService = inject(ChatProgressService);
  private readonly eventLogger = inject(EventLoggerService);
  private readonly conn = inject(ConnectionService);
  public readonly appConfig = inject(AppConfig);

  /** The acting user is globally available — self-fetched to avoid coupling to the parent. */
  protected get user(): Table.User {
    return this.conn.getActingUser();
  }

  openLanguageChangeDrawer(): void {
    if (this.botReplyInProgress() || this.chatProgressService.chatLoading()) return;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'chat-language-change-pill' }));
    this.bottomSheet.open(LanguageChangeComponent, {
      data: {
        translateLastBotQuestionData: this.consultationSessionService
          .getLastBotQuestionTranslationData(this.consultationSession()),
        translateChatMessages: this.translateChatMessages(),
      },
    });
  }
}
